import { useEffect } from 'react';

const FEEDBACK_URL = 'https://declicdigital.systeme.io/feedback';

export default function FeedbackEmbedPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Feedback';

    const head = document.head;
    let robotsMeta = document.querySelector('meta[name="robots"]');
    const previousRobotsContent = robotsMeta?.getAttribute('content') ?? null;

    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      head.appendChild(robotsMeta);
    }

    robotsMeta.setAttribute('content', 'noindex,nofollow,noarchive');

    return () => {
      document.title = previousTitle;

      if (robotsMeta) {
        if (previousRobotsContent === null) {
          robotsMeta.remove();
        } else {
          robotsMeta.setAttribute('content', previousRobotsContent);
        }
      }
    };
  }, []);

  return (
    <main className="h-screen w-full overflow-hidden bg-background">
      <iframe
        title="Feedback"
        src={FEEDBACK_URL}
        className="h-full w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allow="clipboard-read; clipboard-write"
      />
    </main>
  );
}
